<template>
  <svg
    class="icon fill-current"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 2C20.8789 2 22 3.12109 22 4.5V15.75C22 17.1289 20.8789 18.25 19.5 18.25H13.875L8.99609 21.9102C8.6875 22.1367 8.25 21.9141 8.25 21.5312V18.25H4.5C3.12109 18.25 2 17.1289 2 15.75V4.5C2 3.12109 3.12109 2 4.5 2H19.5ZM10.4004 10.0625C9.07546 10.0625 8.00011 11.1206 8 12.4248V13.1562C8 13.6221 8.38421 14 8.85742 14H15.1426C15.6158 14 16 13.6221 16 13.1562V12.4248C15.9999 11.1206 14.9245 10.0625 13.5996 10.0625H13.3018C12.9053 10.2418 12.4643 10.3438 12 10.3438C11.5357 10.3437 11.0965 10.2418 10.6982 10.0625H10.4004ZM12 5C10.7375 5 9.71387 6.00723 9.71387 7.25C9.71387 8.49277 10.7375 9.5 12 9.5C13.2625 9.5 14.2861 8.49277 14.2861 7.25C14.2861 6.00723 13.2625 5 12 5Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'MessageMyIcon'
}
</script>
